export default __webpack_public_path__ + "static/media/stone1.dc520288.png";